import React from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Field, reduxForm } from 'redux-form'
import { compose } from '@reduxjs/toolkit'
import queryString from 'qs'

import { titleCase } from '../utils/stringUtils'
import { renderTextField, Submit, Hint } from '../form'
import { validRequired, validEmail } from '../form/validate'
import UserLocationField from './UserLocationField'
import withCurrentVisit from './withCurrentVisit'

import { InputGroup, Center, AuthToken, Column } from './shared'

const HintWrapper = styled.div`
  margin-top: -20px;
  margin-bottom: 40px;
`

class ConfirmEmail extends React.Component {
  render() {
    const {
      handleSubmit,
      currentUser,
      form,
      currentVisitLoading,
      location,
    } = this.props
    const { source } = queryString.parse(location.search, {
      ignoreQueryPrefix: true,
    })

    const sourceName = titleCase(source)

    return (
      <form
        className="qa-confirm-email"
        action={`/users/${currentUser.id}`}
        method="post"
        ref={(ref) => (this.form = ref)} // eslint-disable-line
        onSubmit={handleSubmit(() => {
          this.form.submit()
        })}
      >
        <AuthToken />
        <input type="hidden" name="_method" value="patch" />

        <div className="container">
          <div className="row">
            <Column className="col-xs-12 col-md-6 col-md-push-3">
              <Field
                label="Email"
                name="user[email]"
                type="email"
                component={renderTextField}
                validate={[validRequired, validEmail]}
                lessMargin
              />

              <HintWrapper>
                {currentUser.email ? (
                  <Hint>
                    {sourceName} gave us this email address. Please confirm that
                    this is one you want to use for your Riparide account. If
                    it&apos;s not, you can change it now.
                  </Hint>
                ) : (
                  <Hint>
                    {sourceName} didn&apos;t give us your email address. We need
                    this to communicate with you about bookings. Please enter
                    your email address now.
                  </Hint>
                )}
              </HintWrapper>

              <UserLocationField formName={form} ready={!currentVisitLoading} />

              <InputGroup>
                <Center>
                  <Submit name="commit" disabled={currentVisitLoading}>
                    Continue
                  </Submit>
                </Center>
              </InputGroup>
            </Column>
          </div>
        </div>
      </form>
    )
  }
}

const ConfirmEmailForm = reduxForm({
  form: 'ConfirmEmail',
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
})(ConfirmEmail)

export default compose(
  withRouter,
  withCurrentVisit,
  connect(({ auth }, { currentVisit, currentVisitLoading }) => ({
    currentUser: auth.currentUser,
    currentVisitLoading,
    initialValues: {
      user: {
        ...auth.currentUser,
        location: currentVisit?.location?.name,
        longitude: currentVisit?.location?.lng,
        latitude: currentVisit?.location?.lat,
      },
    },
  }))
)(ConfirmEmailForm)
